import React, {useState, useEffect} from "react";
import {Nav, NavLink, NavMenu} from "./NavbarElements";
import '../intro.css'

const Navbar = () => {
    const [stickyClass, setStickyClass] = useState('');

    useEffect(() => {
      window.addEventListener('scroll', stickNavbar);
      return () => window.removeEventListener('scroll', stickNavbar);
    }, []);
  
    const stickNavbar = () => {
      if (window !== undefined) {
        let windowHeight = window.scrollY;
        // window height changed for the demo
        windowHeight > 0 ? setStickyClass('sticky-nav') : setStickyClass('');
      }
    };

    return(
        <>
        <div className={`navbar ${stickyClass}`}>
        <Nav>
            <NavLink to="/" activeStyle>
                <h1>ACMC</h1>
            </NavLink>
            {/* <Bars /> */}
            <NavMenu>
                <NavLink to="/About" activeStyle>
                    ABOUT
                </NavLink>
            </NavMenu>
            <NavMenu>
                <NavLink to="/Speakers" activeStyle>
                    SPEAKERS
                </NavLink>
            </NavMenu>
            <NavMenu>
                <NavLink to="/Enrollment" activeStyle>
                    ENROLL IN MAILING LIST

                </NavLink>
            </NavMenu>

            {/* <NavBtnLink to="/signin">Sign In</NavBtnLink> */}
        </Nav>
        </div>
        </>
    )
}
export default Navbar;